import { render, staticRenderFns } from "./GLGallery.vue?vue&type=template&id=76c7b684&scoped=true&"
import script from "./GLGallery.vue?vue&type=script&lang=ts&"
export * from "./GLGallery.vue?vue&type=script&lang=ts&"
import style0 from "./GLGallery.vue?vue&type=style&index=0&id=76c7b684&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c7b684",
  null
  
)

export default component.exports